import React, { FC, useEffect } from 'react'

// third party components
import { useDispatch, useSelector } from 'react-redux'
import { useWallet } from '@solana/wallet-adapter-react'

// custom functions
import { useViewport } from 'utils'

// custom components
import MobileMenu from 'components/Menu/MobileMenu'
import MobileSearchBox from 'components/MobileSearchBox'
import PrimaryHeader from 'components/Header/PrimaryHeader'
import PrimaryFooter from 'components/Footer/PrimaryFooter'
import ConnectWalletModal from 'components/Modal/ConnectWalletModal'
import ProfileSetupModal from 'components/Modal/ProfileSetupModal'
import ShoppingCartMobileMenu from 'components/Menu/ShoppingCartMobileMenu'

// resource

// styles
import styles from './index.module.scss'
import { setColorTheme } from 'utils/helpers'

interface PrimaryLayoutProps {
  children?: any
  head?: React.ReactElement
}

const PrimaryLayout: FC<PrimaryLayoutProps> = ({ children, head }) => {
  const viewport = useViewport()
  const dispatch = useDispatch()
  const openMobileMenu = useSelector<any>(state => state.openMobileMenu)
  const openShoppingCart = useSelector<any>(state => state.openShoppingCart)
  const openMobileSearchBox = useSelector<any>(state => state.openMobileSearchBox)
  const profileSetup = useSelector<any>(state => state.profileSetup)
  const { connected } = useWallet()
  const lightDarkMode = useSelector(state => (state as any).lightMode)
  useEffect(() => {
    let lightDarkMode = localStorage.getItem('lightDarkMode')
    if (lightDarkMode === null || lightDarkMode === undefined) {
      localStorage.setItem('lightDarkMode', 'false')
      setColorTheme(false)
      dispatch({ type: 'set', lightMode: false })
    } else if (lightDarkMode === 'true') {
      setColorTheme(true)
      dispatch({ type: 'set', lightMode: true })
    } else {
      setColorTheme(false)
      dispatch({ type: 'set', lightMode: false })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {head}
      {lightDarkMode !== null && (
        <div className={styles.container}>
          {/* {connected && (viewport === 'lg' || viewport === 'xl' || viewport === '2xl') && <Navbar />} */}
          <PrimaryHeader />
          <ConnectWalletModal />
          {openMobileMenu && (viewport === 'xs' || viewport === 'sm' || viewport === 'md') && <MobileMenu />}
          {openMobileSearchBox && (viewport === 'xs' || viewport === 'sm' || viewport === 'md') && <MobileSearchBox />}
          {openShoppingCart && (viewport === 'xs' || viewport === 'sm' || viewport === 'md') && (
            <ShoppingCartMobileMenu />
          )}

          <main className="w-full flex justify-center mt-[60px] lg:mt-[80px] min-h-[calc(100vh_-_60px)] lg:min-h-[calc(100vh_-_80px)]">
            {children}
          </main>
          {viewport === 'lg' || viewport === 'xl' || viewport === '2xl' ? <PrimaryFooter /> : <></>}
          {connected && profileSetup && <ProfileSetupModal />}
        </div>
      )}
    </>
  )
}

export default PrimaryLayout
